import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewModule = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.67 5V11.5H9.33V5H14.67ZM15.67 11.5H21V5H15.67V11.5ZM14.67 19V12.5H9.33V19H14.67ZM15.67 12.5V19H21V12.5H15.67ZM8.33 12.5H3V19H8.33V12.5ZM8.33 11.5V5H3V11.5H8.33Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgViewModule);
export default ForwardRef;
